// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3C8Lg","col":"styles_col__Dytxp"};